export default __webpack_public_path__ + "static/media/fireflink-platform.707414e1.svg";